export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-bold text-white mb-3 block">91吃瓜爆料</span>
            <p className="text-sm text-foreground-300 leading-relaxed">
              打造最强吃瓜群众社区，汇聚91i吃瓜网核心圈层，每日更新最新娱乐圈爆料，提供91免费吃瓜福利，让每一位用户都能畅快吃瓜。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">吃瓜资讯</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">内容分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">内容分类</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">精彩视频</a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">关于我们</h4>
            <nav className="flex flex-col gap-2">
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">平台介绍</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">下载APP</a>
            </nav>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 mb-8">
          <h4 className="text-sm font-semibold text-white mb-4 text-center">合作伙伴</h4>
          <p className="text-xs text-foreground-500 text-center">
            合作伙伴信息持续更新中，欢迎优质平台洽谈合作
          </p>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 91吃瓜爆料 All Rights Reserved. 本站内容仅供娱乐讨论，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">投诉建议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}